import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Legend,
  Tooltip
} from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Legend, Tooltip);

const BrowserOS = () => {
  const data = {
    labels: ['Browser', 'Browser', 'Browser', 'Browser', 'Browser', 'Browser', 'Browser'],
    datasets: [
      {
        label: 'OS 1',
        data: [600, 2500, 200, 1200, 900, 1100, 1600],
        backgroundColor: '#9bbce2', // soft blue
        borderRadius: 8,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
      {
        label: 'OS 2',
        data: [1600, 900, 400, 2000, 800, 1300, 1500],
        backgroundColor: '#6d4dbf', // violet
        borderRadius: 8,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
      {
        label: 'OS 3',
        data: [400, 700, 1100, 300, 700, 900, 1200],
        backgroundColor: '#cc6ea0', // pinkish
        borderRadius: 8,
        barPercentage: 0.6,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          usePointStyle: true,
          pointStyle: 'circle',
          boxWidth: 10,
          padding: 20,
          font: {
            size: 14,
            family: 'Arial',
          },
        },
      },
      tooltip: {
        enabled: true, // ❌ Turn off tooltip if you also don't want hover values
      },
      datalabels: {
        display: false, // ⛔ Explicitly disable data labels if plugin is registered
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          font: {
            size: 13,
            family: 'Arial',
          },
          color: '#5a5a75',
        },
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        ticks: {
          stepSize: 1000,
          callback: (value) => (value >= 1000 ? value / 1000 + 'k' : value),
          color: '#b0b0c0',
          font: {
            size: 13,
            family: 'Arial',
          },
        },
        grid: {
          color: '#f0f0f0',
          drawBorder: false,
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', maxWidth: '960px', height: '480px', margin: 'auto' }}>
      <Bar data={data} options={options} />
    </div>
  );
};

export default BrowserOS;
